export function getPaginationQuery(currentPage) {
  return currentPage ? `page=${currentPage}` : "";
}